import CheckBoxIcon from "@mui/icons-material/CheckBox";
import axios from "axios";
import moment from "moment";
import { useState } from "react";
import { Col, Container, Modal, Row, Button } from "react-bootstrap";

import { useAuth } from "hooks/useAuth";

export default function ValidatorRecommendPostingModal({
  show,
  handleClose,
  product,
  files,
  refetch,
}) {
  const { authToken, csrfToken } = useAuth();
  const [error, setError] = useState(null);

  const handleUpdateProgressPoint = () => {
    axios
      .put(
        `${import.meta.env.VITE_DJANGO_ENDPOINT}project/product/handle_recommend_for_posting/`,
        { product_id: product?.product_id },
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": csrfToken,
            Authorization: `Token ${authToken}`,
          },
        },
      )
      .then(() => {
        refetch();
        handleClose();
      })
      .catch((error) => {
        setError(error.response.data.error);
      });
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => {
        handleClose();
      }}
    >
      <Modal.Header className="border-0" closeButton>
        <Modal.Title>
          <h3 style={{ whiteSpace: "nowrap" }} className="text-bright-navy">
            RECOMMEND FOR POSTING
          </h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <Row>
                <p className="mb-1 fw-bold">Validator Checkout Files</p>
              </Row>
              <Col className="px-5 pt-3 pb-3 border border-gray-700">
                {files
                  ?.filter((f) =>
                    f?.file_source_type?.includes("Validator Check Out"),
                  )
                  ?.map((file, idx) => (
                    <Row key={idx}>
                      <p className="mb-1">{file?.file_name}</p>
                    </Row>
                  ))}
              </Col>
            </Col>
          </Row>
          <Row>
            <Col className="mt-3">
              {product?.cctl_checkout_signer && (
                <Row>
                  <Col sm={1}>
                    <CheckBoxIcon
                      style={{
                        color: "var(--bs-success)",
                      }}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <p>
                      Evaluator Release Form Completed on{" "}
                      {moment
                        .utc(product?.cctl_checkout_date)
                        .format("MM/DD/YYYY")}{" "}
                      by {product?.cctl_checkout_signer?.first_name}{" "}
                      {product?.cctl_checkout_signer?.last_name},{" "}
                      {product?.cctl_checkout_signer?.org?.name}
                    </p>
                  </Col>
                </Row>
              )}
              {product?.vendor_checkout_signer && (
                <Row>
                  <Col sm={1}>
                    <CheckBoxIcon
                      style={{
                        color: "var(--bs-success)",
                      }}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <p>
                      Vendor Release Form Completed on{" "}
                      {moment
                        .utc(product?.vendor_checkout_date)
                        .format("MM/DD/YYYY")}{" "}
                      by {product?.vendor_checkout_signer?.first_name}{" "}
                      {product?.vendor_checkout_signer?.last_name},{" "}
                      {product?.vendor_checkout_signer?.org?.name}
                    </p>
                  </Col>
                </Row>
              )}
              {product?.labs_cc_draft_cert_verifier && (
                <Row>
                  <Col sm={1}>
                    <CheckBoxIcon
                      style={{
                        color: "var(--bs-success)",
                      }}
                    />
                  </Col>
                  <Col>
                    <p>
                      Evaluator CC Draft Certificate Verified on{" "}
                      {moment
                        .utc(product?.labs_cc_draft_cert_date)
                        .format("MM/DD/YYYY")}{" "}
                      by {product?.labs_cc_draft_cert_verifier?.first_name}{" "}
                      {product?.labs_cc_draft_cert_verifier?.last_name},{" "}
                      {product?.labs_cc_draft_cert_verifier?.org?.name}
                    </p>
                  </Col>
                </Row>
              )}
              {product?.vendors_cc_draft_cert_verifier && (
                <Row>
                  <Col sm={1}>
                    <CheckBoxIcon
                      style={{
                        color: "var(--bs-success)",
                      }}
                    />
                  </Col>
                  <Col>
                    <p>
                      Vendor CC Draft Certificate Verified on{" "}
                      {moment
                        .utc(product?.vendor_cc_draft_cert_date)
                        .format("MM/DD/YYYY")}{" "}
                      by {product?.vendors_cc_draft_cert_verifier?.first_name}{" "}
                      {product?.vendors_cc_draft_cert_verifier?.last_name},{" "}
                      {product?.vendors_cc_draft_cert_verifier?.org?.name}
                    </p>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer className="border-0 p-0">
        {error && (
          <Row>
            <Col xs={12}>
              <p className="text-danger">{error}</p>
            </Col>
          </Row>
        )}
        <div className="d-flex justify-content-end">
          <Button
            style={{ width: "max-content" }}
            className="m-3"
            onClick={handleUpdateProgressPoint}
          >
            Recommend to Post
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
